import DeviationGrid from './DeviationGrid';
export default DeviationGrid;

//# sourceMappingURL=index.js.map